var map = {
	"./baby-leggings.webp": 6117,
	"./baby-leggings@2x.webp": 767213,
	"./backpacks.webp": 385805,
	"./backpacks@2x.webp": 327413,
	"./basic-tote.webp": 389309,
	"./basic-tote@2x.webp": 860549,
	"./beanies-youth.webp": 985669,
	"./beanies-youth@2x.webp": 546189,
	"./bedroom.webp": 29614,
	"./bedroom@2x.webp": 440868,
	"./blanket.webp": 725521,
	"./blanket@2x.webp": 525473,
	"./bottles-and-tumblers.webp": 854070,
	"./bottles-and-tumblers@2x.webp": 497900,
	"./boxer-briefs.webp": 782786,
	"./boxer-briefs@2x.webp": 514896,
	"./boyshorts.webp": 670235,
	"./boyshorts@2x.webp": 31851,
	"./cheeky-briefs.webp": 911343,
	"./cheeky-briefs@2x.webp": 557671,
	"./cotton-fabrics.webp": 736854,
	"./cotton-fabrics@2x.webp": 700492,
	"./cotton-market-tote.webp": 347061,
	"./cotton-market-tote@2x.webp": 893981,
	"./cotton-silk-bandana.webp": 561659,
	"./cotton-silk-bandana@2x.webp": 849995,
	"./day-tote.webp": 805781,
	"./day-tote@2x.webp": 519357,
	"./desk-mat.webp": 791476,
	"./desk-mat@2x.webp": 738,
	"./dresses.webp": 215505,
	"./dresses@2x.webp": 813409,
	"./face-coverings.webp": 648064,
	"./face-coverings@2x.webp": 366774,
	"./headwear.webp": 920603,
	"./headwear@2x.webp": 989675,
	"./hemp-fabrics.webp": 610215,
	"./hemp-fabrics@2x.webp": 855743,
	"./hoodies.webp": 473775,
	"./hoodies@2x.webp": 388711,
	"./kitchen.webp": 791010,
	"./kitchen@2x.webp": 847408,
	"./large-basic-cotton-tote.webp": 199327,
	"./large-basic-cotton-tote@2x.webp": 298423,
	"./large-basic-tote.webp": 557903,
	"./large-basic-tote@2x.webp": 893959,
	"./large-notebooks.webp": 598054,
	"./large-notebooks@2x.webp": 710844,
	"./leggings-and-pants.webp": 694165,
	"./leggings-and-pants@2x.webp": 984957,
	"./living-room.webp": 416545,
	"./living-room@2x.webp": 306001,
	"./long-sleeve-shirts.webp": 346179,
	"./long-sleeve-shirts@2x.webp": 49843,
	"./makeup-bags.webp": 925731,
	"./makeup-bags@2x.webp": 927251,
	"./market-totes.webp": 613696,
	"./market-totes@2x.webp": 837046,
	"./matte-crepe-ruffle-scrunchie.webp": 825693,
	"./matte-crepe-ruffle-scrunchie@2x.webp": 775333,
	"./office.webp": 646362,
	"./office@2x.webp": 996872,
	"./origami-tote.webp": 990817,
	"./origami-tote@2x.webp": 302033,
	"./patches.webp": 714824,
	"./patches@2x.webp": 129630,
	"./performance-polyester-fabrics.webp": 243627,
	"./performance-polyester-fabrics@2x.webp": 543259,
	"./permanent-sticker.webp": 685618,
	"./permanent-sticker@2x.webp": 197024,
	"./pillow-cases.webp": 278107,
	"./pillow-cases@2x.webp": 161131,
	"./premium-drawstring-bag.webp": 405086,
	"./premium-drawstring-bag@2x.webp": 472948,
	"./purses-and-pouches.webp": 135676,
	"./purses-and-pouches@2x.webp": 693674,
	"./robes.webp": 404889,
	"./robes@2x.webp": 920969,
	"./scarves.webp": 436371,
	"./scarves@2x.webp": 362275,
	"./scoop-bralette.webp": 61014,
	"./scoop-bralette@2x.webp": 823564,
	"./seasonal.webp": 393522,
	"./seasonal@2x.webp": 591136,
	"./shorts.webp": 487173,
	"./shorts@2x.webp": 657485,
	"./silk-charmeuse-ruffle-scrunchie.webp": 497223,
	"./silk-charmeuse-ruffle-scrunchie@2x.webp": 144031,
	"./silk-fabrics.webp": 411280,
	"./silk-fabrics@2x.webp": 57702,
	"./skirts.webp": 491050,
	"./skirts@2x.webp": 203832,
	"./small-notebooks.webp": 252922,
	"./small-notebooks@2x.webp": 592424,
	"./spiral-notebooks.webp": 502420,
	"./spiral-notebooks@2x.webp": 135362,
	"./stainless-steel-tumbler.webp": 635870,
	"./stainless-steel-tumbler@2x.webp": 732532,
	"./stationery-cards.webp": 630310,
	"./stationery-cards@2x.webp": 982204,
	"./t-shirts.webp": 740524,
	"./t-shirts@2x.webp": 859898,
	"./tank-tops.webp": 161597,
	"./tank-tops@2x.webp": 359493,
	"./tea-towels.webp": 534967,
	"./tea-towels@2x.webp": 570799,
	"./tote-bags.webp": 515116,
	"./tote-bags@2x.webp": 870842,
	"./unisex-joggers.webp": 994394,
	"./unisex-joggers@2x.webp": 547784,
	"./urban-tote.webp": 42335,
	"./urban-tote@2x.webp": 952951,
	"./vegan-leather-backpack.webp": 61212,
	"./vegan-leather-backpack@2x.webp": 972618,
	"./vegan-leather-crossbody-purse.webp": 627724,
	"./vegan-leather-crossbody-purse@2x.webp": 921946,
	"./vegan-leather-makeup-bag.webp": 886858,
	"./vegan-leather-makeup-bag@2x.webp": 566616,
	"./vegan-leather-tote-bag.webp": 552899,
	"./vegan-leather-tote-bag@2x.webp": 248691,
	"./vegan-leathers.webp": 645544,
	"./vegan-leathers@2x.webp": 317182,
	"./wall-art.webp": 496562,
	"./wall-art@2x.webp": 910688,
	"./woven-polyester-fabrics.webp": 438950,
	"./woven-polyester-fabrics@2x.webp": 830524,
	"./yoga-shorts.webp": 582034,
	"./yoga-shorts@2x.webp": 417024,
	"./youth-leggings.webp": 59332,
	"./youth-leggings@2x.webp": 527890,
	"./zipper-pouches.webp": 616250,
	"./zipper-pouches@2x.webp": 630760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 855412;